import { Form, Input } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const WorkerName: React.FC = () => {
  const {t}=useTranslation()

  return (
    <Form.Item
      name="name"
      label="Name"
      rules={[
        {
          required: true,
          message: t("error:name_is_required"),
        },
      ]}
    >
      <Input />
    </Form.Item>
  );
};

export default WorkerName;
